import { gql } from "gql";

export const GET_MODULES_INFO = gql(`
  query GetModulesInfo {
    getModulesInfo {
      module
    }
  }
`);
